import { render, staticRenderFns } from "./500.vue?vue&type=template&id=4b2b0ce3&scoped=true&"
import script from "./500.vue?vue&type=script&lang=ts&"
export * from "./500.vue?vue&type=script&lang=ts&"
import style0 from "./500.vue?vue&type=style&index=0&id=4b2b0ce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b0ce3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
